import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    ExpectedContainerStatus,
} from 'app/enums/label.enums'
import {
    DamageType,
} from './DamageTypes.types'

const config: SkyNetTableConfig<keyof DamageType> = {
    name: 'DamageType',
    tabs: [{
        name: 'All',
        url: 'all',
        fields: [
            {
                name: 'name',
                labelKey: 'DamageTypes.damageTypeName',
                reduced: true,
            },
            {
                name: 'expectedContainerStatus',
                labelKey: 'DamageTypes.expectedContainerStatus',
                allowedValuesEnum: ExpectedContainerStatus,
                componentName: 'EnumValue',
                filterField: 'expectedContainerStatus',
                filterType: FilterType.Array,

            },
            {
                name: 'expectedFixingDays',
                labelKey: 'DamageTypes.expectedFixingDays',
                filterField: 'expectedFixingDays',
                filterType: FilterType.Array,
            },
            {
                name: 'comment',
                labelKey: 'DamageTypes.comment',
            },
            {
                name: 'blocksQcPassed',
                labelKey: 'DamageTypes.blocksQcPassed',
                componentName: 'ChipCheckMark',
            },
        ],
    }],
}

export default config
